const style = require('./index.css');

export interface ILabelProps {
  text: string;
  backgroundColor?: string;
  textColor?: string;
}

/**
 * Значения по умолчанию заданы параметрами, а не через defaultProps:
 * React 19 больше не применяет defaultProps к функциональным компонентам.
 */
export const Label = ({ text, backgroundColor = '#FF9D00', textColor = '#FFFFFF' }: ILabelProps) => (
  <div
    className={style['label']}
    style={{
      backgroundColor,
      color: textColor,
    }}
  >
    {text}
  </div>
);
